module.exports = __webpack_public_path__ + "img/live-xrp-txs.1fa0b5f5.png";